angular.module('nv.components.tooltip', []);
